/*
 * Copyright (c) by INFODATA-GROUP. All rights reserved.
 * No part of this publication may be reproduced, distributed,
 * or transmitted in any form or by any means, including photocopying, recording,
 * or other electronic or mechanical methods, without the prior written permission of the publisher,
 * except in the case of brief quotations embodied in critical
 * reviews and certain other noncommercial uses permitted by copyright law.
 *  author : vhe
 *  date : 02/03/2021 07:39
 */

import { Pipe, PipeTransform } from '@angular/core';
import { ModelProperty } from '../engine/model-property';

/**
 * Pipe model driven check if enable and enableRule is respected
 */
@Pipe({
  name: 'enable',
  standalone: true,
})
export class EnablePipe implements PipeTransform {
  transform(property: ModelProperty, args?: any): any {
    const data = args;
    if (property.enable && property.enableRule && data) {
      if (Array.isArray(property.enableRule.value)) {
        return !property.enableRule.value.indexOf(
          data[property.enableRule.field],
        );
      } else {
        return data[property.enableRule.field] === property.enableRule.value;
      }
    } else {
      return property.enable;
    }
  }
}
